import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

interface SmallQRCodeProps {
  url: string;
  size?: number;
}

const SmallQRCode: React.FC<SmallQRCodeProps> = ({ url, size = 60 }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    generateQRCode();
  }, [url]);

  const generateQRCode = async () => {
    setIsGenerating(true);
    setError('');
    
    try {
      const qrCodeUrl = await QRCode.toDataURL(url, {
        width: size,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
      setQrCodeDataUrl(qrCodeUrl);
    } catch (err) {
      console.error('QRコード生成エラー:', err);
      setError('QRコードの生成に失敗しました');
    } finally {
      setIsGenerating(false);
    }
  };

  if (error) {
    return (
      <div className="flex items-center justify-center" style={{ width: size, height: size }}>
        <span className="text-xs text-red-500">エラー</span>
      </div>
    );
  }

  if (isGenerating) {
    return (
      <div className="flex items-center justify-center" style={{ width: size, height: size }}>
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center" style={{ width: size, height: size }}>
      {qrCodeDataUrl && (
        <img 
          src={qrCodeDataUrl} 
          alt="QRコード" 
          className="w-full h-full"
          style={{ width: size, height: size }}
        />
      )}
    </div>
  );
};

export default SmallQRCode;
